import { render, staticRenderFns } from "./myFavorite.vue?vue&type=template&id=5b37df64&scoped=true&"
import script from "./myFavorite.vue?vue&type=script&lang=js&"
export * from "./myFavorite.vue?vue&type=script&lang=js&"
import style0 from "./myFavorite.vue?vue&type=style&index=0&id=5b37df64&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37df64",
  null
  
)

export default component.exports